import { ApiModule, type PaginatedResponseData } from '@common/index';
import { SpecialityGroupType } from '../../../../master-data/speciality/models';
import type { TopicHasEducationalRequirementItem, TopicHasEducationalRequirement } from '../models';

export class TopicHasEducationalRequirementApi extends ApiModule {
  protected endpoint = '/topic-has-educational-requirement';

  public async pageTopicHasEducationalRequirements(params: any) {
    return this.api.post<PaginatedResponseData<TopicHasEducationalRequirementItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadTopicHasEducationalRequirementDetails(id: number) {
    return this.api.get<TopicHasEducationalRequirement>(`${this.endpoint}?id=${id}`);
  }

  public saveTopicHasEducationalRequirement(params: any, topicId: number) {
    return this.api.post(`${this.endpoint}/create-relations`, {
      ...params,
      topicId: topicId
    });
  }

  public deleteTopicHasEducationalRequirement(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public getMasterData(topicId: number, specialityGroupType: SpecialityGroupType) {
    return this.api.get<any>(`${this.endpoint}/master-data`, { params: { topicId, specialityGroupType } });
  }

  public deleteSelected(selectedIds: number[], topicId: number) {
    return this.api.post(`${this.endpoint}/delete-relations?topicId=${topicId}`, { ids: selectedIds });
  }
}
